import { cn } from "@fronterahealth/frontera-ui-components/lib/utils";
import { FieldError } from "@fronterahealth/frontera-ui-components/ui/field";
import { Label } from "@fronterahealth/frontera-ui-components/ui/label";
import { RadioGroup, RadioGroupItem } from "@fronterahealth/frontera-ui-components/ui/radio-group";

import { ReportFieldDisabledValue } from "@components/ReportField/ReportFieldDisabledValue";
import { parseRadioContent } from "@components/ReportField/inputs/choiceContent";
import { ReportFieldInputProps } from "@components/ReportField/types";

export const ReportFieldRadio: React.FC<ReportFieldInputProps> = ({
  id,
  value,
  onChange,
  variant,
  disabled,
  ariaInvalid,
}) => {
  const result = parseRadioContent(value);

  if (!result.success) return <FieldError errors={result.error.issues} />;

  const { options, answer } = result.data;

  if (disabled) return <ReportFieldDisabledValue value={answer} />;

  return (
    <RadioGroup
      value={answer}
      onValueChange={(next) => {
        onChange(JSON.stringify({ options, answer: String(next) }));
      }}
      className={cn(
        "flex gap-8",
        "min-h-10 rounded-lg border border-input px-4 py-2",
        "aria-invalid:border-semantic-stroke-negative aria-invalid:ring-3 aria-invalid:ring-semantic-stroke-negative/20",
        variant === "ghost" &&
          "-my-2 transition-[color,box-shadow,padding,border-color] [&:not(:hover):not(:focus-visible)]:border-transparent [&:not(:hover):not(:focus-visible)]:pl-0 [&:not(:hover):not(:focus-visible)]:pr-8",
      )}
      aria-invalid={ariaInvalid}
    >
      {options.map((option) => (
        <div key={option} className="flex items-center gap-3">
          <RadioGroupItem id={`${id}-${option}`} value={option} />
          <Label htmlFor={`${id}-${option}`}>{option}</Label>
        </div>
      ))}
      {answer && (
        <div className="flex items-center gap-3">
          <RadioGroupItem id={`${id}-empty`} value={""} />
          <Label htmlFor={`${id}-empty`}>--</Label>
        </div>
      )}
    </RadioGroup>
  );
};
